import { FormField } from 'components/form/customFormField'
import { Label } from 'components/form/form.style'
import React, { useState } from 'react'

import { IncrementFieldContainer, LabelWheelContainer } from '../form/EventForm.style'

interface IncrementFieldWithToggleProps {
    control: any
    errors: any
    defaultIncrement?: number | string
    onIncrementChange: (value: number) => void
}

export const IncrementFieldWithToggle: React.FC<IncrementFieldWithToggleProps> = ({
    control,
    errors,
    defaultIncrement = 1000,
    onIncrementChange,
}) => {
    const [showInput, setShowInput] = useState(false)

    return (
        <IncrementFieldContainer>
            <LabelWheelContainer>
                <Label>Alapértelmezett kategória lépték</Label>
                <button
                    type="button"
                    aria-label="Toggle increment input"
                    onClick={() => setShowInput((prev) => !prev)}
                    style={{
                        border: 'none',
                        background: 'none',
                        cursor: 'pointer',
                        fontSize: '1.2em',
                        color: '#666',
                        padding: 0,
                        marginLeft: '4px',
                    }}
                >
                    <i className="pi pi-cog"></i>
                </button>
            </LabelWheelContainer>

            {showInput && (
                <FormField
                    name="increment"
                    control={control}
                    errors={errors}
                    defaultValue={defaultIncrement}
                    min={0}
                    type="number"
                    onChange={(e) => onIncrementChange(Number(e.target.value))}
                />
            )}
        </IncrementFieldContainer>
    )
}
